// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomFormikCheckbox_wrapper__e7Ig-","error":"CustomFormikCheckbox_error__kijoL"};